module.exports = __webpack_public_path__ + "static/ce2020.1827a1b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ce2020.jpg
// module id = 139
// module chunks = 35783957827783 218406353984926